import { propType } from "graphql-anywhere";

export default propType;
